import React from "react";
import ReactDOM from "react-dom";
import App, { Editor } from "./App";
import registerServiceWorker from "./registerServiceWorker";

const props = {
  type: 1,
  businessId: "1",
  API: "http://api.links123.net/comment/v1",
  showList: false
};

const editorProps = {
  showEmoji: true,
  placeholder: "说点什么吧",
  rows: 5
  // onSubmit={v => console.log()} // TODO...
};

ReactDOM.render(
  <App {...props}>
    <Editor {...editorProps} />
  </App>,
  document.getElementById("root-comment")
);
registerServiceWorker();
